import axios from 'axios'
import ConfigProvider from 'balkerne-core/config'

export const createApi = () => {
  return axios.create({
    baseURL: ConfigProvider.backendEndpoint,
    responseType: 'json',
  })
}

// This is the main API instance
export const api = createApi()

export default api
